export default __webpack_public_path__ + "static/media/coffe-1.a1ae28c6.jpg";